import { render, staticRenderFns } from "./StHighlightBulletList.vue?vue&type=template&id=6dc544da"
import script from "./StHighlightBulletList.vue?vue&type=script&lang=ts"
export * from "./StHighlightBulletList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports